const AUTH_FLAG_KEY = 'platforma_has_auth';

/**
 * Имя ключа флага сессии в localStorage.
 *
 * Экспортируется ради слушателя `storage` в httpClient: он ловит выход,
 * сделанный в соседней вкладке, и должен сверять `event.key` с этим же
 * значением, а не с собственным литералом-двойником.
 */
export const AUTH_FLAG_STORAGE_KEY = AUTH_FLAG_KEY;

/**
 * Момент последней выдачи access-токена.
 *
 * Сам токен лежит в HttpOnly-куке (SIMPLE_JWT.AUTH_COOKIE_HTTP_ONLY), поэтому
 * прочитать его `exp` с клиента нельзя — о свежести httpClient судит по этому
 * стемпу. Хранится рядом с флагом сессии: оба описывают «что клиент знает про
 * свою сессию», и гасить их надо одним движением (clearAuthFlag на logout).
 */
const ACCESS_MINTED_AT_KEY = 'platforma_access_minted_at';

// Fallback на случай недоступного localStorage (Safari private mode): без него
// стемп не сохранялся бы никогда, «токен протух» было бы истиной всегда и
// каждый запрос тянул бы за собой лишний refresh.
let mintedAtMemo = 0;

export const setAuthFlag = () => {
    try {
        localStorage.setItem(AUTH_FLAG_KEY, '1');
    } catch (e) {
        console.warn('Cannot set auth flag', e);
    }
};

export const clearAuthFlag = () => {
    mintedAtMemo = 0;
    try {
        localStorage.removeItem(AUTH_FLAG_KEY);
        localStorage.removeItem(ACCESS_MINTED_AT_KEY);
    } catch (e) {
        console.warn('Cannot clear auth flag', e);
    }
};

export const hasAuthFlag = () => {
    try {
        return localStorage.getItem(AUTH_FLAG_KEY) === '1';
    } catch {
        return false;
    }
};

/** Момент последней выдачи access-токена; 0 — неизвестен. */
export const readAccessMintedAt = (): number => {
    try {
        return Number(localStorage.getItem(ACCESS_MINTED_AT_KEY)) || mintedAtMemo;
    } catch {
        return mintedAtMemo;
    }
};

/** Отметить, что access-токен только что выдан (успешный /token/refresh/). */
export const markAccessMinted = (): void => {
    const now = Date.now();
    mintedAtMemo = now;
    try {
        localStorage.setItem(ACCESS_MINTED_AT_KEY, String(now));
    } catch {
        /* приватный режим / переполненное хранилище — переживём */
    }
};

export { AUTH_FLAG_KEY, ACCESS_MINTED_AT_KEY };
